import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';

@Component({
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm) => {
      if(vm.getIsToken && vm.getSubscription) {
        next('/mi-menu/comenzar');
      } else {
        next();
      }
    });
  }
})
export default class SubscriptionsGetStarted extends Vue {
  
  @Action action_getAllSubscriptions;

  @Getter getSubscription;
  @Getter getIsToken;
  @Getter getUser;
  @Getter getCity;

  @Mutation PATH_TEMPORAL;


  currentStep = 1;

  get getSteps() {
    let response = [
      { value: 1, label: "Platos" },
      { value: 2, label: "Preferencias" },
      { value: 3, label: "Entrega" }
    ];
    if (this.getSubscription) {
      response[2].label = "Pago y Entrega";
    }
    return response;
  }



  async mounted() {
    if(this.getIsToken && this.getCity && this.getCity.id) {
      try {
        await this.action_getAllSubscriptions({ commerceId: this.getCity.id });
        if(this.getSubscription) {
          this.$router.replace({ name: 'subscriptions_settingsNew' });
        }
      } catch (error) {
        let msg = "";
        if (error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        }
        this.$swal({
          title: "Error",
          text: "¡Ups! Hubo un error enviando la solicitud. " + msg
        });
      }
    }
  }

  _onGetStarted() {
    if(this.getIsToken) {
      this.$router.push('/mi-menu/welcome');
    }
    else {
      this._login
    }
    
  } 

  _login() {
    const name = this.$route.name
    const query = this.$route.query
    const params = this.$route.params
    this.PATH_TEMPORAL({ name, params, query })
    this.$router.push('/ingresar/login');
  }

  _onLogin(option: string) {
    const name = this.$route.name;
    const query = this.$route.query;
    const params = this.$route.params;
    params["modal"] = option;

    this.PATH_TEMPORAL({ name, params, query });
    this.$router.push({ name: 'login' });
  }
}